<style scoped lang="scss">
/* clear fix */
.grid:after {
    content: '';
    display: block;
    clear: both;
}

.grid-item {
    float: left;
    padding-bottom: 30px;

    .gallery-image {
        width: 100%;
        filter: sepia(.3);

        &:hover {
            filter: none;
        }
    }
}

</style>

<template>
    <div :id="id" class="grid">
        <slot :arrange="arrange" :show="show"></slot>

        <image-modal v-if="showModal" :startIndex="index" :images="images" @close="showModal = false"></image-modal>
    </div>
</template>

<script>
    import Isotope from 'isotope-layout';

    export default {

        props: {
            images: Array,
        },

        data() {
            return {
                id: '',
                iso: null,
                showModal: false,
                index: 0,
            };
        },

        created() {
            this.id = 'box_' + Math.random().toString(36).substring(7);
            this.prepareComponent();
        },

        methods: {

            prepareComponent() {
                setTimeout(() => {

                    this.iso = new Isotope( '#' + this.id, {
                        itemSelector: '.grid-item',
                        transitionDuration: '.5s',
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-item'
                        },
                    });

                });
            },

            arrange() {
                if (this.iso) {
                    this.iso.arrange();
                }
            },

            show(index) {
                this.index = index;
                this.showModal = true;
            },
        },

    }
</script>
